import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import jobType from "./types/jobType";
import ErrorsOrForm from "./ErrorsOrForm";
import JobStatus from "./JobStatus";
import JobDescription from "./JobDescription";
import "./styles/RequestEngagement.scss";

class RequestEngagement extends PureComponent {
  componentDidMount() {
    window.$('[data-toggle="tooltip"]').tooltip();
  }

  render() {
    const {
      job,
      errors,
      createEngagementPath,
      updateEngagementPath,
      hasExistingEngagement,
      recruiterIsOnPsl,
      recruiterIsInJobAudience,
      avgResponseTime,
      isPortalUser,
      isPartnerUser,
    } = this.props;

    return (
      <div>
        <ul className="nav nav-tabs">
          <li className="active job-details-li">
            <a
              href="#job-details"
              className="job-details-link"
              title="Job details"
              data-toggle="tab"
            >
              JOB DETAILS
            </a>
          </li>
          <li className="job-status-li">
            <a
              href="#job-status"
              className="job-status-link"
              data-toggle="tab"
              title="Job status"
            >
              JOB STATUS
            </a>
          </li>
        </ul>

        <div className="tab-content clearfix">
          <div className="tab-pane fade in active" id="job-details">
            <JobDescription
              job={job}
              isPortalUser={isPortalUser}
              isPartnerUser={isPartnerUser}
            />
            {(!hasExistingEngagement || isPartnerUser) && (
              <ErrorsOrForm
                job={job}
                errors={errors}
                createEngagementPath={createEngagementPath}
                updateEngagementPath={updateEngagementPath}
                recruiterIsOnPsl={recruiterIsOnPsl}
                recruiterIsInJobAudience={recruiterIsInJobAudience}
                isPartnerUser={isPartnerUser}
              />
            )}
          </div>
          <div className="tab-pane fade" id="job-status">
            <JobStatus job={job} avgResponseTime={avgResponseTime} />
          </div>
        </div>
      </div>
    );
  }
}

RequestEngagement.propTypes = {
  job: jobType.isRequired,
  errors: PropTypes.shape({
    base: PropTypes.arrayOf(PropTypes.string),
    message: PropTypes.arrayOf(PropTypes.string),
    recruiter: PropTypes.arrayOf(PropTypes.string),
  }),
  createEngagementPath: PropTypes.string.isRequired,
  updateEngagementPath: PropTypes.string.isRequired,
  hasExistingEngagement: PropTypes.bool.isRequired,
  recruiterIsOnPsl: PropTypes.bool,
  recruiterIsInJobAudience: PropTypes.bool,
  avgResponseTime: PropTypes.string,
  isPortalUser: PropTypes.bool.isRequired,
  isPartnerUser: PropTypes.bool.isRequired,
};

RequestEngagement.defaultProps = {
  errors: {},
  recruiterIsOnPsl: false,
  recruiterIsInJobAudience: false,
  avgResponseTime: PropTypes.isNull,
};

export default RequestEngagement;
